var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({class:['btn--icon-mini ui', { 'btn--xs': _vm.xs }],attrs:{"small":"","md-icon":_vm.mdIcon || 'add',"round":"","mini":""}},'BaseButton',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }